import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import TagsInput from 'components/form/tagsinput'
import {
  cond,
  either,
  isNil,
  isEmpty,
  always,
  defaultTo,
  complement,
  map,
  split,
  flatten,
  unless,
  startsWith,
  concat,
  pipe,
  filter
} from 'ramda'
import withFieldError from 'components/form/with-error'

export const FacebookHashtag = ({
  input: { value, onChange, ...input },
  meta: { error, touched }
}) => (
  <div className={error && touched && 'has-error'}>
    <TagsInput
      inputProps={{
        placeholder: 'Enter hashtag e.g. #hashtag',
        className: 'react-tagsinput-input input-medium',
        ...input,
        onBlur: input.onBlur.bind(input, value)
      }}
      addOnBlur
      value={value}
      onChange={onChange}
    />
  </div>
)

FacebookHashtag.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const FacebookHashtagWithError = withFieldError(FacebookHashtag)

const noValue = either(isNil, isEmpty)

export const validate = cond([[noValue, always('Please enter valid hashtags')]])

export const normalize = pipe(
  map(split(' ')),
  flatten,
  filter(complement(isEmpty)),
  map(unless(startsWith('#'), concat('#')))
)

const FacebookHashtagField = ({ name }) => (
  <div>
    <Field
      name={`${name}.value`}
      component={FacebookHashtagWithError}
      validate={validate}
      format={defaultTo([])}
      normalize={normalize}
    />
    <Field name={`${name}.primary`} component='input' type='hidden' value />
  </div>
)

FacebookHashtagField.propTypes = {
  name: PropTypes.string
}

export default FacebookHashtagField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/facebook/hashtag/index.js